var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("app-nav"),
      _vm._v(" "),
      _c("google-map", { attrs: { name: "google" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/App.vue?vue&type=template&id=60e7249d&
// module id = 54
// module chunks = 0